import Vue from 'vue';
import Vuex from 'vuex';
import auth from '@/store/auth';
import vouchers from '@/store/vouchers';
import invoices from '@/store/invoices';
import products from '@/store/products';
import bookings from '@/store/bookings';
import messages from '@/store/messages';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    vouchers,
    invoices,
    products,
    bookings,
    messages,
  },
});
